export default __webpack_public_path__ + "static/media/device-offline-24px.3bb5d93d.svg";